<template>
  <div>
    <v-container>
      <v-toolbar flat color="white">
        <v-text-field
          v-model="search_str"
          label="搜索"
          clearable
          >
        </v-text-field>
        <v-btn @click="reload" small color="success" style="margin-left:10px;"><v-icon>search</v-icon>搜索</v-btn>
        <v-spacer></v-spacer>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-dialog v-model="dlgEdit" max-width="600px">
          <template v-slot:activator="{attrs, on}">
            <v-btn v-bind="attrs" v-on="on" color="primary" small dark class="mb-2" @click="addItem">添加客户</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ dlgTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">名称</span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="edItem.title" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">简称</span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="edItem.abbr" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">地址</span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="edItem.address" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">联系人</span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="edItem.contacter" dense solo></v-text-field>
                  </v-col>
                  <v-col cols="2" class="fld">
                    <span class="flds">电话</span>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field v-model="edItem.phone" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">联系人</span>
                  </v-col>
                  <v-col cols="8">
                    <v-text-field v-model="edItem.note" dense solo></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="cancel">取消</v-btn>
              <v-btn color="primary" @click="save">确定</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="customers"
        :server-items-length="pagination.totalItems"
        :loading="loading"
        hide-default-footer
        class="elevation-1">
        <template v-slot:item.act="{item}">
          <v-btn small @click="editItem(item)" color="success"><v-icon>edit</v-icon>修改</v-btn>
          <v-btn small @click="deleItem(item)" color="error" style="margin-left:4px;"><v-icon>delete</v-icon>删除</v-btn>
        </template>
        <template slot="no-data">
          没有数据
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pagination.totalPages"></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import { getCustomerList, addCustomer, modifyCustomer, deleteCustomer } from '@/api/customer'
import { MsgError } from '@/libs/util';

export default {
  components: {
  },
  data: () => ({
    search_str: '',
    dlgRight: false,
    dlgEdit: false,
    edID: 0,
    edItem: {
      title: '',
      abbr: '',
      address: '',
      contacter: '',
      phone: '',
      note: ''
    },
    headers: [
      { text: '名称', value: 'title', sortable: false },
      { text: '简称', value: 'abbr', sortable: false },
      { text: '地址', value: 'address', sortable: false },
      { text: '联系人', value: 'contacter', sortable: false },
      { text: '电话', value: 'phone', sortable: false },
      { text: '备注', value: 'note', sortable: false },
      { text: '操作', value: 'act', sortable: false, width: 200 }
    ],
    customers: [],
    pagination: {
      page: 0,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: 0,
      totalPages: 0
    },
    loading: false
  }),
  methods: {
    addItem () {
      this.edID = 0
      this.edItem.title = ''
      this.edItem.abbr = ''
      this.edItem.address = ''
      this.edItem.contacter = ''
      this.edItem.phone = ''
      this.edItem.note = ''
    },
    editItem (item) {
      this.edID = item.id
      this.edItem = Object.assign({}, item)
      this.dlgEdit = true
    },
    doDele (id) {
      deleteCustomer(id).then(res => {
        this.reload()
      })
    },
    deleItem (item) {
      this.$swal.fire({
        title: '警告',
        text: '确实要删除码?',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doDele(item.id);
        }
      })
    },
    cancel () {
      this.dlgEdit = false
    },
    save () {
      if (this.edItem.title === undefined || this.edItem.title === '') {
        MsgError('名称不能为空')
        return
      }
      if (this.edID > 0) {
        modifyCustomer(this.edID, this.edItem.title, this.edItem.abbr, this.edItem.address,
          this.edItem.contacter, this.edItem.phone, this.edItem.note).then(res => {
          this.reload()
        })
      } else {
        addCustomer(this.edItem.title, this.edItem.abbr, this.edItem.address, this.edItem.contacter,
          this.edItem.phone, this.edItem.note).then(res => {
          this.reload()
        })
      }
      this.cancel()
    },
    reload () {
      let d = {
        'kw': this.search_str,
        'page': this.pagination.page,
        'perPage': this.pagination.rowsPerPage
      }
      this.loading = true
      getCustomerList(d).then(res => {
        this.customers = res.data.items
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.pagination.page = res.data._meta.total_pages
        } else {
          this.pagination.page = res.data._meta.page
        }
        this.pagination.totalPages = res.data._meta.total_pages
        this.pagination.totalItems = res.data._meta.total_items
        this.loading = false
      })
    }
  },
  computed: {
    dlgTitle () {
      return this.edID <= 0 ? '添加客户' : '修改客户'
    }
  },
  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    }
  },
  mounted () {
    this.reload()
  }
}
</script>
